import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { EqBaseComponent } from '../eq-base/eq-base.component';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
const Material = [
  MatInputModule,
  MatFormFieldModule,
  MatRippleModule,
  MatIconModule,
];
@Component({
  selector: 'eq-phone-number',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ...Material
  ],
  templateUrl: './phone-number.component.html',
  styleUrl: './phone-number.component.scss',
})
export class PhoneNumberComponent extends EqBaseComponent implements OnInit{



}
